/* eslint-disable no-console */
import React from 'react'
import styled from 'styled-components'

import Checkbox from 'components/Checkboxes/Checkbox'
import Flex from 'components/Flex'
import Icon from 'components/Icon'
import Text from 'components/Text'
import { Row as RowType, TabularCheckboxProps } from './types'

type StyleProps = {
  isEditing?: boolean
  isDisabled?: boolean
  isFirst?: boolean
  isLast?: boolean
  onChange?: TabularCheckboxProps['onChange']
}

type Props = RowType & StyleProps & { groupIndex: number }
const greenCheck = <Icon icon={['fas', 'check']} color="green1" />

const redMark = <Icon icon="times" color="red1" />

const Row: React.FC<Props> = ({ isEditing, label, onChange, rowId, value, groupIndex, ...props }) => {
  const result =
    label !== null ? (
      <StyledRow {...props}>
        <td>
          <Text lineHeight="2.5rem">{label}</Text>
        </td>
        {value.map((columnValue, index) => (
          <td key={`${label}-${rowId}-${index}`}>
            <Flex justifyContent="center">
              {isEditing ? (
                <Checkbox
                  name={`${rowId}-${index}`}
                  checked={columnValue}
                  disabled={props.isDisabled}
                  onChange={(checked) => {
                    if (!onChange || columnValue === checked) return

                    const newValue = [...value]
                    newValue[index] = checked

                    onChange(groupIndex, rowId, newValue)
                  }}
                />
              ) : columnValue ? (
                greenCheck
              ) : (
                redMark
              )}
            </Flex>
          </td>
        ))}
      </StyledRow>
    ) : null
  return result
}

const StyledRow = styled.tr<StyleProps>`
  background-color: ${({ theme }) => theme.colors.gray2};

  td:first-child {
    padding-left: 4rem;
    width: auto;
    text-align: start;
  }

  td:not(:first-child) {
    width: 100px;
  }
`

export default Row
